<template>
  <div class="sidebar-container" :class="{ 'is-collapse': isCollapse }">
    <!-- 折叠按钮 -->
    <div class="sidebar-toggle" @click="toggleSidebar">
      <el-icon>
        <component :is="isCollapse ? 'Expand' : 'Fold'" />
      </el-icon>
    </div>
    
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        @select="handleMenuSelect"
      >
        <sidebar-item
          v-for="route in menuList"
          :key="route.menuCode"
          :item="route"
          :base-path="'/'"
          :is-collapse="isCollapse"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SidebarItem from './SidebarItem.vue'

export default {
  name: 'SidebarComponent',
  components: {
    SidebarItem
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    
    const isCollapse = computed(() => !store.state.app.sidebar.opened)
    const menuList = computed(() => store.state.menu.menuList)
	console.log('========',store.state.menu.menuList);
    
    const activeMenu = computed(() => {
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    })
    
    const handleMenuSelect = (index) => {
      router.push(index)
    }
    
    const toggleSidebar = () => {
      store.dispatch('app/toggleSideBar')
    }
    
    return {
      isCollapse,
      menuList,
      activeMenu,
      handleMenuSelect,
      toggleSidebar
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 60px; // 位于导航栏下方
  left: 0;
  bottom: 0;
  width: 210px;
  background-color: #304156;
  z-index: 999; // 降低层级，确保在导航栏下方
  transition: width 0.28s;
  
  // 折叠按钮
  .sidebar-toggle {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #263445;
    border-radius: 4px;
    cursor: pointer;
    color: #bfcbd9;
    transition: all 0.3s;
    z-index: 1002;
    
    &:hover {
      background-color: #409eff;
      color: #fff;
    }
  }
  
  // 折叠状态
  &.is-collapse {
    width: 64px;
    
    .sidebar-toggle {
      right: 15px;
    }
  }
  
  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }
  
  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
    background-color: #304156;
    
    // 一级菜单项样式
    :deep(.el-menu-item) {
      color: #bfcbd9;
      background-color: #304156;
      
      &:hover {
        background-color: #263445 !important;
        color: #fff;
      }
      
      &.is-active {
        background-color: #409eff !important;
        color: #fff;
      }
    }
    
    // 一级菜单（有子菜单）
    :deep(.el-sub-menu) {
      .el-sub-menu__title {
        color: #bfcbd9;
        background-color: #304156;
        
        &:hover {
          background-color: #263445 !important;
          color: #fff;
        }
      }
      
      &.is-opened > .el-sub-menu__title {
        color: #fff;
        background-color: #263445;
      }
      
      // 二级菜单项样式
      .el-menu-item {
        color: #bfcbd9;
        background-color: #263445;
        padding-left: 50px !important;
        
        &:hover {
          background-color: #1f2d3d !important;
          color: #fff;
        }
        
        &.is-active {
          background-color: #409eff !important;
          color: #fff;
        }
      }
      
      // 二级子菜单
      .el-sub-menu {
        .el-sub-menu__title {
          color: #bfcbd9;
          background-color: #263445;
          padding-left: 50px !important;
          
          &:hover {
            background-color: #1f2d3d !important;
            color: #fff;
          }
        }
        
        &.is-opened > .el-sub-menu__title {
          color: #fff;
          background-color: #1f2d3d;
        }
        
        // 三级菜单项
        .el-menu-item {
          color: #bfcbd9;
          background-color: #1f2d3d;
          padding-left: 70px !important;
          
          &:hover {
            background-color: #0f1419 !important;
            color: #fff;
          }
          
          &.is-active {
            background-color: #409eff !important;
            color: #fff;
          }
        }
      }
    }
  }
  
  &.collapse {
    width: 64px;
    
    // 调整折叠状态下的箭头位置
    :deep(.el-sub-menu .el-sub-menu__title .el-sub-menu__icon-arrow) {
      right: 8px !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
      margin-top: 0 !important;
      font-size: 12px !important;
      color: #bfcbd9 !important;
      transition: all 0.3s !important;
    }
    
    :deep(.el-sub-menu:hover .el-sub-menu__title .el-sub-menu__icon-arrow) {
      color: #fff !important;
      transform: translateY(-50%) scale(1.1) !important;
    }
  }
}

// 自定义折叠菜单弹出样式
:deep(.el-menu--popup) {
  background-color: #304156 !important;
  border: 1px solid #263445 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  padding: 12px 0 !important;
  min-width: 180px !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
}

:deep(.el-menu--popup .el-menu-item) {
  color: #bfcbd9 !important;
  background-color: transparent !important;
  padding: 0 20px !important;
  height: 42px !important;
  line-height: 42px !important;
  margin: 3px 12px !important;
  border-radius: 6px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #263445 !important;
  color: #fff !important;
  transform: translateX(2px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  background-color: #409eff !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3) !important;
}

:deep(.el-menu--popup .el-menu-item.is-active::before) {
  content: '' !important;
  position: absolute !important;
  left: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 3px !important;
  height: 20px !important;
  background-color: #fff !important;
  border-radius: 0 2px 2px 0 !important;
}

:deep(.el-menu--popup .el-menu-item .el-icon) {
  margin-right: 10px !important;
  font-size: 16px !important;
  transition: transform 0.3s !important;
}

:deep(.el-menu--popup .el-menu-item:hover .el-icon) {
  transform: scale(1.1) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-sub-menu__title) {
  color: #bfcbd9 !important;
  background-color: transparent !important;
  padding: 0 20px !important;
  height: 42px !important;
  line-height: 42px !important;
  margin: 3px 12px !important;
  border-radius: 6px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
}

:deep(.el-menu--popup .el-sub-menu .el-sub-menu__title:hover) {
  background-color: #263445 !important;
  color: #fff !important;
  transform: translateX(2px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-sub-menu__title .el-icon) {
  margin-right: 10px !important;
  font-size: 16px !important;
  transition: transform 0.3s !important;
}

:deep(.el-menu--popup .el-sub-menu .el-sub-menu__title:hover .el-icon) {
  transform: scale(1.1) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu) {
  background-color: #263445 !important;
  border-radius: 6px !important;
  margin: 6px 12px !important;
  padding: 4px 0 !important;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item) {
  color: #bfcbd9 !important;
  background-color: transparent !important;
  padding: 0 30px !important;
  height: 38px !important;
  line-height: 38px !important;
  margin: 2px 6px !important;
  border-radius: 4px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item:hover) {
  background-color: #1f2d3d !important;
  color: #fff !important;
  transform: translateX(2px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item.is-active) {
  background-color: #409eff !important;
  color: #fff !important;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3) !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item.is-active::before) {
  content: '' !important;
  position: absolute !important;
  left: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 3px !important;
  height: 18px !important;
  background-color: #fff !important;
  border-radius: 0 2px 2px 0 !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item .el-icon) {
  margin-right: 8px !important;
  font-size: 14px !important;
  transition: transform 0.3s !important;
}

:deep(.el-menu--popup .el-sub-menu .el-menu .el-menu-item:hover .el-icon) {
  transform: scale(1.1) !important;
}
</style>
